import { init } from '@sentry/browser';
import Vue from 'vue'
import Sticky from 'vue-sticky-directive'
import VTooltip from 'v-tooltip'

import App from './App.vue'
import router from './router'
import store from './store'
import '@/misc/register-service-worker'
import '@/misc/handle-network-status'
import '@/misc/handle-apple-install-prompt'
import 'pwacompat'
import { arrayDiff, urlMaker } from '@/helpers/Util';
import { formatMoney } from '@/helpers/Currency';
import { getHostname, formatUrl, IsDomainValid, getQueryVariable } from '@/helpers/Url';
import { humanise } from '@/helpers/Date';
import Card from '@/components/Card';

Vue.use(VTooltip)
Vue.use(Sticky)

Vue.component('Card', Card)

Vue.mixin({
  methods: {
    arrayDiff,
    urlMaker,
    formatUrl,
    getHostname,
    humanise,
    formatMoney,
    IsDomainValid,
    getQueryVariable
  }
})

Vue.config.productionTip = false

// Sentry
init({
  dsn: 'https://a22bcaefe0d6489c815b345bcb0d5a10@sentry.io/1476317',
});

new Vue({
  router,
  store,
  mounted () {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event('render-event'))

    window.onload = function(){
      const anchors = document.querySelectorAll('article a');
      for (let i=0; i<anchors.length; i++){
        anchors[i].setAttribute('target', '_blank');
      }
    }
  },
  render: h => h(App)
}).$mount('#app')
